import { ACTIONS } from '../const';
import { createAction } from 'redux-actions';

const { SET_CONTENT, CLEAR_CONTENT } = ACTIONS;

export const setContent = createAction(SET_CONTENT);
export const clearContent = createAction(CLEAR_CONTENT);



// WEBPACK FOOTER //
// ./src/actions/manage_content.js